/* eslint-disable */
import store, { isD2C } from '@/store'
import { reportPerformance } from '@/apis/order'
import { App } from 'vue'

// 当前页面加载后唯一id
export const loadedID = Date.now().toString() + Math.random().toString().slice(1)

declare type Action<T extends keyof Types = keyof Types> = Readonly<{
    type: T
    case: Types[T]
    loadedID: string
    time: number
    curShop: any
}>

interface Types {
    response: {
        url: string,
        status: number,
        res: {
            code: string,
            data: string
        }
    },
    responsefail: {
        url: string,
        status: number,
        text: string
    },
    click: {
        action: string,
        data: any[]
    },
    err: {
        type: string,
        stack: any,
        records?: Action[]
    }
}

const t: any = process.env.NODE_ENV === 'production' ? window : {}
export const bury = (action: string, ...rest: string[]) => {
    if (!action) return
    const channel = store.state.bussiness.schannel
    save({
        type: 'click',
        case: {
            action,
            data: [channel, ...rest]
        }
    })
    if (t._czc?.push) {
        t._czc.push(['_trackEvent', action.replace('{plat}', isD2C() ? '2C' : '2B'), channel, ...rest])
    } else {
        console.log('bury =>', action.replace('{plat}', isD2C() ? '2C' : '2B'))
    }
}

const actionRecords: Action[] = []

export const save = <T extends keyof Types>(item: { type: T, case: Types[T] }) => {
    const action = {
        ...item,
        loadedID,
        time: Date.now(),
        curShop: store.getters.curShop
    }
    actionRecords.push(action)
    if (actionRecords.length > 10) {
        actionRecords.shift()
    }
}

// export const report = (Case: Types['err']) => {
//     Case.records = [...actionRecords]
//     const error = {
//         type: 'error',
//         case: Case,
//         loadedID,
//         time: Date.now(),
//         curShop: store.getters.curShop,
//     }
//     console.log(error)
//     if (t._czc?.push) {
//         t._czc.push(['_trackEvent', 'error', JSON.stringify(error)])
//     }
// }

export const reportLoadedPerformance = () => {
    window.addEventListener('DOMContentLoaded', e => {
        // 加载页面前置所需的资源列表
        const resourceList: any = performance.getEntriesByType("resource")
        const source: any = []
        for (let i = 0; i < resourceList.length; i++) {
            if (resourceList[i].responseEnd - resourceList[i].startTime > 1000) {
                source.push({
                    name: resourceList[i].name,
                    time: (resourceList[i].responseEnd - resourceList[i].startTime).toFixed(2) + 'ms',
                })
            }
        }
        setTimeout(() => {
            const p: any = performance
            // console.log(performance)
            // for (let k in p) {
            //     console.log(k, p[k])
            // }
            let time = performance.timing
            let data: any = {
                loadedID,
                page: location.href,
                customerId: store.getters.user?.customerId,
                shopId: store.getters.curShop,
            }
            let timingObj: any = {}
            timingObj['重定向时间'] = (time.redirectEnd - time.redirectStart) / 1000
            timingObj['DNS解析时间'] = (time.domainLookupEnd - time.domainLookupStart) / 1000
            timingObj['TCP完成握手时间'] = (time.connectEnd - time.connectStart) / 1000
            timingObj['HTTP请求响应完成时间'] = (time.responseEnd - time.requestStart) / 1000
            timingObj['DOM开始加载前所花费时间'] = (time.responseEnd - time.navigationStart) / 1000
            timingObj['DOM结构解析完成时间'] = (time.domInteractive - time.domLoading) / 1000
            timingObj['DOM加载完成时间'] = (time.domComplete - time.domInteractive) / 1000
            timingObj['脚本加载时间'] = (time.domContentLoadedEventEnd - time.domContentLoadedEventStart) / 1000
            timingObj['白屏时间'] = (time.domInteractive - time.fetchStart) / 1000
            timingObj['页面完全加载时间'] = (time.domContentLoadedEventEnd - time.fetchStart) / 1000
            let dict: any = {
                '重定向时间': 'redirect',
                'DNS解析时间': 'dns_parse',
                'TCP完成握手时间': 'tcp_content',
                'HTTP请求响应完成时间': 'http_response',
                'DOM开始加载前所花费时间': 'before_dom_parse',
                'DOM结构解析完成时间': 'dom_parse_complete',
                'DOM加载完成时间': 'dom_render_complete',
                '脚本加载时间': 'script_load_complete',
                '白屏时间': 'wait_blank',
                '页面完全加载时间': 'page_load_complete',
            }
            for (let k in timingObj) {
                data[dict[k]] = timingObj[k]
            }
            //
            data.source = source
            process.env.NODE_ENV === 'production' ? reportPerformance(data) : console.log(data)
        }, 2000)
    })
}

reportLoadedPerformance()

// declare module '@vue/runtime-core' {
//     export interface ComponentCustomProperties {
//         bury: (action: string, ...rest: string[]) => void
//     }
// }

export const globalBury = (app: App) => {
    app.config.globalProperties.bury = bury
}
